import { render } from "./EntityRemovalConfirm.vue?vue&type=template&id=d116d7c6"
import script from "./EntityRemovalConfirm.vue?vue&type=script&lang=js"
export * from "./EntityRemovalConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__